import * as actionTypes from '../actionType';

const classState = {
  classListParams: {}, // 调用送对象的list的参数
  classListObject: {},// 班级列表入参
}
export default {
  classListParams(state = classState.classListParams, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_CLASS_LIST_PARAMS:
        return payload;
      default:
    }

    return state;
  },
  classListObject(state = classState.classListObject, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_CLASS_LIST_OBJECT:
        return payload;
      default:
    }

    return state;
  }
};
